export const USERINFOKEY = 'userinfokey'
